"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function onVideoLoad(event) {
  this.setState({
    hasFired: {}
  });
  this.props.onVideoLoad(event);
}

exports.default = onVideoLoad;


//////////////////
// WEBPACK FOOTER
// ./~/react-jw-player/dist/create-event-handlers/on-video-load.js
// module id = 1787
// module chunks = 1